<section class="single-value-boolean">
  <h4>{{ data.label }}</h4>
  <mat-checkbox
    [checked]="data.state.value"
    (change)="onDataChange($event.checked)"
    >{{ data.label }}</mat-checkbox
  >
</section>
